import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
// By path, not the icons index: that re-exports palette.jsx into the entry chunk.
import { ChatLogoIcon } from "components/ui/icons/chat";

/**
 * The floating chat button. Dragging it sideways moves it to the other side of
 * the page (its height never changes); the small × hides it until the next
 * page load. State lives in `useChatLauncher`, owned by the layout because the
 * chat window above the button follows it to the same side.
 */
const ChatLauncher = ({ isChatOpen, onToggle, launcher }) => {
  const { t } = useTranslation();
  const { isHidden, hide, offset, isDragging, consumeDrag, dragHandlers } =
    launcher;

  if (isHidden) return null;

  const handleClick = () => {
    // The click that ends a drag is not a request to open the chat.
    if (consumeDrag()) return;
    onToggle();
  };

  return (
    <div
      className={`group relative mb-4 touch-none select-none ${
        isChatOpen ? "" : "fixed bottom-4"
      }`}
      style={isDragging ? { transform: `translateX(${offset}px)` } : undefined}
      {...dragHandlers}
    >
      <ChatLogoIcon
        className={`cursor-pointer pointer-events-auto chat-toggle-icon w-[71px] h-[71px] ${
          isChatOpen ? "chat-icon-active" : ""
        }`}
        onClick={handleClick}
      />
      {!isChatOpen && (
        <button
          type="button"
          aria-label={t("chat.hide_launcher")}
          title={t("chat.hide_launcher")}
          // Pressing the × must not start a drag of the launcher under it.
          onPointerDown={(event) => event.stopPropagation()}
          onClick={hide}
          className="absolute -top-1 -end-1 z-30 flex h-6 w-6 items-center justify-center rounded-full border border-border-light bg-surface text-xs text-secondary shadow-sm opacity-0 transition-opacity hover:text-danger focus-visible:opacity-100 group-hover:opacity-100 [@media(hover:none)]:opacity-100"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
};

export default ChatLauncher;
